module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Mis datos editables")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos personales")]), (_vm.isLoading) ? _c('loading') : _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Apellido paterno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.apellidoPaterno),
      expression: "empleado.apellidoPaterno"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.apellidoPaterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "apellidoPaterno", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Apellido materno")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.apellidoMaterno),
      expression: "empleado.apellidoMaterno"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.apellidoMaterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "apellidoMaterno", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Nombres")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.nombres),
      expression: "empleado.nombres"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.nombres)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "nombres", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Genero")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.genero === 'F'
    },
    on: {
      "click": function($event) {
        _vm.empleado.genero = 'F'
      }
    }
  }, [_c('span', [_vm._v("F")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.genero === 'M'
    },
    on: {
      "click": function($event) {
        _vm.empleado.genero = 'M'
      }
    }
  }, [_c('span', [_vm._v("M")])])])])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Fecha de nacimiento")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaNacimiento),
      expression: "empleado.fechaNacimiento"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
    },
    domProps: {
      "value": (_vm.empleado.fechaNacimiento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaNacimiento", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Teléfono personal")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.telefonoPersonal),
      expression: "empleado.telefonoPersonal"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.telefonoPersonal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "telefonoPersonal", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Email personal")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.emailPersonal),
      expression: "empleado.emailPersonal"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.emailPersonal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "emailPersonal", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Grado académico")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.gradoAcademico),
      expression: "empleado.gradoAcademico"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.gradoAcademico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "gradoAcademico", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("DNI")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.dni),
      expression: "empleado.dni"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.empleado.dni)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "dni", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Dirección actual de residencia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.direccion),
      expression: "empleado.direccion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.direccion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "direccion", $event.target.value)
      }
    }
  })])])])], 1), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos salud y emergencia")]), (_vm.isLoading) ? _c('loading') : _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Tipo de Sangre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.tipoSangre),
      expression: "empleado.tipoSangre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.tipoSangre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "tipoSangre", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Nombre contacto de emergencia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.nombreEmergencia),
      expression: "empleado.nombreEmergencia"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.nombreEmergencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "nombreEmergencia", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Telefono contacto de emergencia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.telefonoEmergencia),
      expression: "empleado.telefonoEmergencia"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.telefonoEmergencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "telefonoEmergencia", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Alergias a algun medicamento")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.alergiasMedicamento),
      expression: "empleado.alergiasMedicamento"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.empleado.alergiasMedicamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "alergiasMedicamento", $event.target.value)
      }
    }
  })])])], 1), _c('section', {
    staticClass: "section-familia"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos de familia")]), (_vm.isLoading) ? _c('loading') : _c('div', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "flex contenedor-transition contenedor-familia",
    attrs: {
      "name": "fade-smooth"
    }
  }, [_c('div', {
    key: "tiene-conyugue",
    staticClass: "control"
  }, [_c('p', [_vm._v("¿Tiene conyugue?")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.estaCasado
    },
    on: {
      "click": function($event) {
        _vm.empleado.estaCasado = true
      }
    }
  }, [_c('span', [_vm._v("Si")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': !_vm.empleado.estaCasado
    },
    on: {
      "click": function($event) {
        _vm.empleado.estaCasado = false
      }
    }
  }, [_c('span', [_vm._v("No")])])])]), (_vm.empleado.estaCasado) ? _c('div', {
    key: "datos-conyugue",
    staticClass: "flex flex-1 contenedor-conyugue"
  }, [_c('div', {
    staticClass: "flex flex-1"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Nombre de conyugue")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.nombreConyugue),
      expression: "empleado.nombreConyugue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.nombreConyugue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "nombreConyugue", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("DNI/CE conyugue")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.dniConyugue),
      expression: "empleado.dniConyugue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.empleado.dniConyugue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "dniConyugue", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Fecha de nacimiento conyugue")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaNacimientoConyugue),
      expression: "empleado.fechaNacimientoConyugue"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
    },
    domProps: {
      "value": (_vm.empleado.fechaNacimientoConyugue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaNacimientoConyugue", $event.target.value)
      }
    }
  })])])]) : _vm._e()]), _c('transition-group', {
    staticClass: "flex contenedor-transition contenedor-familia",
    attrs: {
      "name": "fade-smooth"
    }
  }, [_c('div', {
    key: "tiene-hijos",
    staticClass: "control"
  }, [_c('p', [_vm._v("¿Tiene hijos?")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.tieneHijos
    },
    on: {
      "click": function($event) {
        _vm.empleado.tieneHijos = true
      }
    }
  }, [_c('span', [_vm._v("Si")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': !_vm.empleado.tieneHijos
    },
    on: {
      "click": function($event) {
        _vm.empleado.tieneHijos = false
      }
    }
  }, [_c('span', [_vm._v("No")])])])]), (_vm.empleado.tieneHijos) ? _c('transition-group', {
    key: "contenedor-hijos",
    staticClass: "flex flex-1 contenedor-transition contenedor-hijos",
    attrs: {
      "name": "fade-smooth"
    }
  }, [_vm._l((_vm.hijos), function(o, index) {
    return _c('div', {
      key: 'hijos_' + index,
      staticClass: "flex-1 contenedor-hijo"
    }, [_c('div', {
      staticClass: "flex contenedor-hijo-break-1"
    }, [_c('div', {
      staticClass: "flex flex-1"
    }, [_c('div', {
      staticClass: "control flex-1"
    }, [_c('p', [_vm._v("Nombre hijo")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.nombre),
        expression: "o.nombre"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (o.nombre)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "nombre", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control"
    }, [_c('p', [_vm._v("DNI/CE hijo")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.dni),
        expression: "o.dni"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (o.dni)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "dni", $event.target.value)
        }
      }
    })])]), _c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "control flex-1"
    }, [_c('p', [_vm._v("Fecha de nacimiento hijo")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.fechaNacimiento),
        expression: "o.fechaNacimiento"
      }],
      staticClass: "input",
      attrs: {
        "type": "date",
        "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}"
      },
      domProps: {
        "value": (o.fechaNacimiento)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "fechaNacimiento", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "flex contenedor-genero"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('p', [_vm._v("Genero")]), _c('div', {
      staticClass: "opciones"
    }, [_c('div', {
      staticClass: "opcion",
      class: {
        'active': o.genero === 'F'
      },
      on: {
        "click": function($event) {
          o.genero = 'F'
        }
      }
    }, [_c('span', [_vm._v("F")])]), _c('div', {
      staticClass: "opcion",
      class: {
        'active': o.genero === 'M'
      },
      on: {
        "click": function($event) {
          o.genero = 'M'
        }
      }
    }, [_c('span', [_vm._v("M")])])])]), _c('div', {
      staticClass: "button button-quitar-hijo",
      on: {
        "click": function($event) {
          return _vm.quitarHijo(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])])])])])
  }), (_vm.empleado.tieneHijos) ? _c('div', {
    key: "agregar-hijo",
    staticClass: "contenedor-boton-agregar-hijo",
    attrs: {
      "name": "Agregar hijo"
    },
    on: {
      "click": _vm.agregarHijoVacio
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('span', [_vm._v("Agregar")])])]) : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos del trabajo")]), (_vm.isLoading) ? _c('loading') : _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Anexo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.anexo),
      expression: "empleado.anexo"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.empleado.anexo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "anexo", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Celular de trabajo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.celularTrabajo),
      expression: "empleado.celularTrabajo"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.empleado.celularTrabajo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "celularTrabajo", $event.target.value)
      }
    }
  })])])])], 1), _c('section', {
    staticClass: "contenedor-guardar"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": _vm.guardar
    }
  }, [_vm._m(0), _c('span', [_vm._v("Guardar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save fa-fw fa-lg"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3091949a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Datos_Personales_Editable.vue
// module id = 855
// module chunks = 0